export const customConfig = {
    API_URL: 'https://api.openalliance.ng/api'
}